<template>
  <div>

    <!--导航栏     @click-left="onClickLeft"  left-arrow  left-text="返回" start-->
    <!-- <van-nav-bar title="选择门店" right-text="添加门店" fixed @click-right="onClickRight" /> -->
    <!--导航栏 end-->

    <van-list v-model="loading" class="list select-shop" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(admin, index) in list" :key="index">
        <div class="list-item" @click="onSubmit(admin.store_num)">
          <div style="display: flex;align-items: center;width: 60%;">
            <div class="txt1">{{ admin.store_name }}</div>
            <div class="title">门店</div>
          </div>
          <div style="display: flex;align-items: center;">
            <div class="txt2">{{ admin.store_num }}</div>
            <img style="width: 24px;height: 24px;margin-left: 8px;" src="../../assets/images/right-icon.png" alt="" srcset="">
          </div>
        </div>
      </div>
      <div class="txt3" @click="onClickRight">
        <img style="width: 16px;height: 16px;margin-right: 8px;" src="../../assets/images/link.png" alt="" srcset="">
        <div>绑定新的商户或门店</div>
      </div>
    </van-list>

    <!-- <van-list v-model="loading" class="list select-shop" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell
        v-for="(admin, index) in list"
        :key="index"
        size="large"
        :title="admin.store_name"
        is-link
        :value="admin.store_num"
        @click="onSubmit(admin.store_num)"
      />
    </van-list> -->
  </div>
</template>

<script>

import { Notify, Toast } from 'vant'

export default {
  name: 'StoreImpower', // 选择门店登录
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 2,
      ta: '111'
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  mounted() {
    // this.onSubmit()
    this.GetQueryString('openid')
  },
  methods: {
    // 左侧返回
    // onClickLeft() {
    //   this.$router.push("/");
    //   // window.history.go(-1)
    // },
    onClickRight() {
      this.$router.push('/MerchantLogin')
      // Toast('添加商户');
    },

    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        window.localStorage.setItem('openid', unescape(r[2]))
        return unescape(r[2])
      }

      return null
    },

    // 点击商户登录
    onSubmit(e) {
      window.sessionStorage.setItem('tag', this.ta)
      var toast = Toast.loading({
        duration: 0,
        message: '登录中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.$http.get('/wechat/login/login', {
        params: {
          openid: window.localStorage.getItem('openid'),
          account: e,
          type: 'store'
        }
      }).then(response => {
        toast.clear()
        console.log(response.data)
        if (response.data.code == 200) {
          window.sessionStorage.setItem('commercialId', response.data.data.merchant_id)
          window.sessionStorage.setItem('tokens', response.data.data.token)
          window.sessionStorage.setItem('store_id', response.data.data.store_id)
          // window.sessionStorage.setItem("username",this.username)

          this.$router.push('/StoreHomepage')

          // VueCookie.set('salesmanInfo', response.data.data, 360000);
          // window.location.href = that.redirect;
        } else {
          Notify({ type: 'danger', message: response.data.msg })
        }
      })
    },

    onLoad() {
      // window.location.href = `http://192.168.3.9:80/wechat/login/authLogin`

      var that = this
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http.get('/wechat/login/lst', {
        params: {
          // id: salesmanInfo.id,
          openid: window.localStorage.getItem('openid'),
          page: that.page,
          limit: that.limit,
          type: 'store'
        }
      }).then(response => {
        // 加载状态结束
        that.loading = false
        // console.log(response.data.data)
        // that.list = that.list.concat(response.data)
        // console.log(that.list)
        // 页码

        // this.finished = true;
        if (response.data.data.length) {
          that.list.push(...response.data.data)
          that.finished = false
          that.page++
        } else { that.finished = true }
      })
    }

  }
}
</script>

<style scoped>
.list {
  /* margin-top: 1rem; */
  padding: 0.5rem;
  white-space: nowrap;
}

.list-item {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  height: 54px;
  padding: 0 10px;
  background-color: rgba(20, 134, 251, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .txt1 {
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    color: #FFFFFF;
    font-size: 18px;
    margin-right: 8px;
  }

  .title{
    width: 34px;
    text-align: center;
    height: 18px;
    line-height: 18px;
    border-radius: 6px;
    font-size: 12px;
    color: rgba(20, 134, 251, 1);
    background-color: #fff;
  }

  .txt2 {
    color: #FFFFFF;
    font-size: 18px;
  }
}

.txt3 {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 50px;
  font-size: 12px;
  color: #1486FB;
}
</style>
